module.exports = __webpack_public_path__ + "static/media/footerbg.9ae450d1.png";